import React from 'react';
import classNames from 'classnames';
import { Select } from 'components/forms/Select';
import { SelectValueTemplate, SelectViewProps } from 'components/forms/Select/Select.view';
import { UseFormReturn } from 'react-hook-form';
import classes from './CustomPublishingModalRow.module.scss';
import { PauseStates } from '../Pause.controller';

export type CustomPublishingRowProps = {
  noBorder?: boolean;
  children: React.ReactNode;
  useFormInstance: UseFormReturn;
  fieldName: string;
};

export const CustomPublishingModalRowView = ({
  children,
  noBorder,
  useFormInstance,
  fieldName
}: CustomPublishingRowProps): JSX.Element => {
  const valueTemplate: SelectValueTemplate = (props: SelectViewProps, globalClasses: string) => {
    return (
      <div
        className={classNames(globalClasses, classes.SelectValue)}
        onClick={e => {
          e.stopPropagation();
          props.setExpanded(!props.expanded);
        }}>
        <div>
          <div
            className={classNames(classes.ColoredCircle, {
              [classes.Fill]: props.selectedValue === PauseStates.Active
            })}>
            <div />
          </div>
          <span>{props.selectedValue}</span>
        </div>
      </div>
    );
  };

  const contentCellClasses = classNames('cell', 'auto');
  const actionCellClasses = classNames('cell', 'shrink');

  return (
    <div
      className={classNames(
        classes.CustomPublishingRow,
        { 'no-b-bor': noBorder },
        'grid-x grid-padding-x align-justify'
      )}>
      <div className={contentCellClasses}>{children}</div>
      <div className={actionCellClasses}>
        <Select
          items={[
            { label: PauseStates.Active, value: PauseStates.Active },
            { label: PauseStates.Paused, value: PauseStates.Paused }
          ]}
          name={fieldName}
          size={'medium'}
          rules={{}}
          useFormInstance={useFormInstance}
          valueTemplate={valueTemplate}
        />
      </div>
    </div>
  );
};
